import { uniq, uniqBy } from 'lodash';
import CustomColumnsButton from 'shared/ui/components/listings/CustomColumnsButton.vue';

export default {
    components: { CustomColumnsButton },

    data() {
        const { routeOptions: { crudOpts = {} } } = this.controller;
        const controllerName = Object.keys(this.module.controllers).find(c => this.controller.route === this.module.controllers[c].route);
        const hasCreatePermission = this.$services.user.hasPermission('event_actions.manage_custom_columns', {
            event_id: this.event._id,
            org_id: this.event.ownerId
        });
        return {
            hasCustomColumns: Boolean(crudOpts.useCustomColumns?.enabled),
            showCustomColumnsButton: Boolean(crudOpts.useCustomColumns?.enabled) && hasCreatePermission,
            customColumnsSettingsKey: `${controllerName}-custom-columns`,
            allCustomColumns: [],
            selectedCustomColumns: []
        };
    },

    methods: {
        /**
         * Loads all available column fields and those previously selected
         */
        async loadColumns() {
            if (!this.hasCustomColumns) {
                return;
            }

            try {
                let columns = await this.$services.appScripts.callAppScript(this.event._id, this.crudOpts.useCustomColumns?.appscript);
                columns = uniqBy(this.columns.concat(columns), 'field');

                const mandatoryColumns = this.columns.filter(f => f.link).map(f => f.field);
                let selectedColumns = await this.$services.settings.getSetting(this.event._id, this.customColumnsSettingsKey);
                if (Array.isArray(selectedColumns) && selectedColumns.length) {
                    selectedColumns = uniq(selectedColumns.concat(mandatoryColumns));
                } else {
                    selectedColumns = this.columns.map(c => c.field);
                }
                this.selectedCustomColumns = selectedColumns;
                this.allCustomColumns = columns;

                this.columns = this.getOrderedSelectedColumns(columns, selectedColumns);
            } catch (err) {
                console.error('[FpTypedList] Failed to custom columns', err.message);
                this.selectedCustomColumns = this.columns.map(c => c.field);
                this.allCustomColumns = this.columns;
            }
        },

        /**
         * Handles change of selected columns
         *
         * @param {Object[]} selectedColumns
         */
        handleColumnsChange(selectedColumns) {
            this.columns = this.getOrderedSelectedColumns(this.allCustomColumns, selectedColumns);
        },

        /**
         * Gets selected columns in correct order
         *
         * @param {Object[]} columns
         * @param {String[]} selected
         */
        getOrderedSelectedColumns(columns, selected) {
            return selected.map(field => columns.find(c => c.field === field));
        }
    }
};
